import { Button } from '@/components/ui/button';
import { useEffect, useRef, useState } from 'react';
import { Group, Panel, Separator } from 'react-resizable-panels';
import { PlaygroundPane, type PlaygroundPaneApi } from './PlaygroundPane';

function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches,
  );
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isDesktop;
}

export function Playground() {
  const leftRef = useRef<PlaygroundPaneApi>(null);
  const rightRef = useRef<PlaygroundPaneApi>(null);
  const [bothLoading, setBothLoading] = useState(false);
  const isDesktop = useIsDesktop();

  const runBoth = async () => {
    setBothLoading(true);
    try {
      await Promise.all([leftRef.current?.run(), rightRef.current?.run()]);
    } finally {
      setBothLoading(false);
    }
  };

  return (
    <div className="flex h-full min-h-0 flex-col">
      {/* 컨트롤 바 */}
      <div className="flex items-center gap-2 border-b border-border px-3 py-2">
        <div className="text-xs text-foreground-muted hidden sm:block">
          두 패널의 프롬프트/버전/엔드포인트를 독립적으로 골라 비교 실행할 수 있습니다.
        </div>
        <div className="ml-auto flex gap-2">
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => leftRef.current?.run()}
          >
            좌측만
          </Button>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => rightRef.current?.run()}
          >
            우측만
          </Button>
          <Button type="button" size="sm" onClick={runBoth} disabled={bothLoading}>
            {bothLoading ? '실행 중…' : '동시 실행'}
          </Button>
        </div>
      </div>

      {/* 좌우(데스크탑) / 위아래(모바일) 분할 */}
      <Group orientation={isDesktop ? 'horizontal' : 'vertical'} className="flex-1 min-h-0">
        <Panel defaultSize="50%" minSize="20%">
          <PlaygroundPane paneKey="left" apiRef={leftRef} />
        </Panel>
        <Separator
          className={
            isDesktop
              ? 'w-px bg-border hover:bg-accent transition-colors'
              : 'h-px bg-border hover:bg-accent transition-colors'
          }
        />
        <Panel defaultSize="50%" minSize="20%">
          <PlaygroundPane paneKey="right" apiRef={rightRef} />
        </Panel>
      </Group>
    </div>
  );
}
